import React, { FC } from 'react'

const Sorting:FC = () => {
  return (
    <div className='title__container'>
        <div className="title__wrapper">
            <img src="/img/widgets/sorting.png" alt=''/>
        </div>
    </div>
  )
}

export default Sorting